import React, { useState, useRef, useEffect } from 'react';

// ── Chart type icon ────────────────────────────────────────────────────────────

export const ChartIcon = ({ type, size = 14 }) => {
  const icons = {
    gantt: (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="currentColor">
        <path d="M2 3h4v2H2V3zm0 4h6v2H2V7zm0 4h9v2H2v-2z"/>
      </svg>
    ),
    timeline: (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="currentColor">
        <path d="M1 2.5a.5.5 0 01.5-.5h13a.5.5 0 010 1h-13a.5.5 0 01-.5-.5zM1 6a.5.5 0 01.5-.5h7a.5.5 0 010 1h-7A.5.5 0 011 6zm0 3.5a.5.5 0 01.5-.5h10a.5.5 0 010 1h-10a.5.5 0 01-.5-.5zm0 3.5a.5.5 0 01.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5z"/>
      </svg>
    ),
    dashboard: (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="currentColor">
        <path d="M1 2a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1H2a1 1 0 01-1-1V2zm9 0a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1V2zM1 9a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1H2a1 1 0 01-1-1V9zm9-1a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 01-1 1h-2a1 1 0 01-1-1V8z"/>
      </svg>
    ),
  };
  return icons[type] || icons.gantt;
};

// ── Context menu ───────────────────────────────────────────────────────────────

const ContextMenu = ({ x, y, node, onClose, onRename, onDelete, onNewItem, onShare }) => {
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [onClose]);

  return (
    <div
      ref={ref}
      className="rp-context-menu"
      style={{
        left: Math.min(x, window.innerWidth - 190),
        top: Math.min(y, window.innerHeight - 210),
      }}
    >
      {node.type === 'folder' && (
        <>
          <button className="rp-ctx-item" onClick={() => { onNewItem(node.id, 'folder'); onClose(); }}>
            <svg viewBox="0 0 16 16" fill="currentColor" width="13" height="13">
              <path d="M9.828 3h3.982a2 2 0 011.992 2.192l-.522 4.957A2 2 0 0113.292 12H3.706a2 2 0 01-1.982-1.851l-.395-5.93A2 2 0 013.31 2h6.516a1 1 0 01.707.293L9.828 3z"/>
            </svg>
            New Sub-folder
          </button>
          <button className="rp-ctx-item" onClick={() => { onNewItem(node.id, 'doc'); onClose(); }}>
            <svg viewBox="0 0 16 16" fill="currentColor" width="13" height="13">
              <path d="M4 0a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4.414A2 2 0 0013.414 3L11 .586A2 2 0 009.586 0H4zM8 5a.5.5 0 01.5.5v2h2a.5.5 0 010 1h-2v2a.5.5 0 01-1 0v-2h-2a.5.5 0 010-1h2v-2A.5.5 0 018 5z"/>
            </svg>
            New Summary
          </button>
          <div className="rp-ctx-divider" />
        </>
      )}
      {node.type !== 'folder' && (
        <button className="rp-ctx-item" onClick={() => { onShare(node); onClose(); }}>
          <svg viewBox="0 0 16 16" fill="currentColor" width="13" height="13">
            <path d="M11 2.5a2.5 2.5 0 11.603 1.628l-6.97 4.02a2.5 2.5 0 010 1.704l6.97 4.02a2.5 2.5 0 11-.56.866l-6.985-4.028a2.5 2.5 0 110-3.444L10.44 3.366A2.5 2.5 0 0111 2.5z"/>
          </svg>
          Share
        </button>
      )}
      <button className="rp-ctx-item" onClick={() => { onRename(node); onClose(); }}>
        <svg viewBox="0 0 16 16" fill="currentColor" width="13" height="13">
          <path d="M12.146.146a.5.5 0 01.708 0l3 3a.5.5 0 010 .708l-10 10a.5.5 0 01-.168.11l-5 2a.5.5 0 01-.65-.65l2-5a.5.5 0 01.11-.168l10-10z"/>
        </svg>
        Rename
      </button>
      <div className="rp-ctx-divider" />
      <button className="rp-ctx-item danger" onClick={() => { onDelete(node); onClose(); }}>
        <svg viewBox="0 0 16 16" fill="currentColor" width="13" height="13">
          <path d="M5.5 5.5A.5.5 0 016 6v6a.5.5 0 01-1 0V6a.5.5 0 01.5-.5zm2.5 0a.5.5 0 01.5.5v6a.5.5 0 01-1 0V6a.5.5 0 01.5-.5zm3 .5a.5.5 0 00-1 0v6a.5.5 0 001 0V6z"/>
          <path d="M14.5 3a1 1 0 01-1 1H13v9a2 2 0 01-2 2H5a2 2 0 01-2-2V4h-.5a1 1 0 010-2h11a1 1 0 011 1zm-8.5 0v-.5h4V3h-4z"/>
        </svg>
        Delete
      </button>
    </div>
  );
};

// ── Single tree item ───────────────────────────────────────────────────────────

const TreeItem = ({ node, depth = 0, activeDocId, activeFolderId, onSelect, onToggle, onContextMenu, onRename, onDelete, onShare }) => {
  const isFolder = node.type === 'folder';
  const isActive = isFolder ? node.id === activeFolderId : node.id === activeDocId;
  const indent = 4 + depth * 14;

  return (
    <>
      <div
        className={`rp-tree-item${isActive ? ' active' : ''}`}
        style={{ paddingLeft: indent }}
        onClick={() => isFolder ? onToggle(node) : onSelect(node)}
        onContextMenu={(e) => { e.preventDefault(); onContextMenu(e, node); }}
      >
        {isFolder ? (
          <button
            className={`rp-tree-item-chevron${node.expanded ? ' open' : ''}`}
            onClick={(e) => { e.stopPropagation(); onToggle(node); }}
          >
            <svg viewBox="0 0 16 16" fill="currentColor"><path d="M6 3.5l4.5 4.5L6 12.5V3.5z"/></svg>
          </button>
        ) : (
          <div style={{ width: 18, flexShrink: 0 }} />
        )}

        <div
          className="rp-tree-item-icon"
          style={{ color: isFolder ? '#f59e0b' : (node.color || 'var(--color-brand)') }}
        >
          {isFolder ? (
            <svg viewBox="0 0 16 16" fill="currentColor" width="14" height="14">
              <path d="M9.828 3h3.982a2 2 0 011.992 2.192l-.522 4.957A2 2 0 0113.292 12H3.706a2 2 0 01-1.982-1.851l-.395-5.93A2 2 0 013.31 2h6.516a1 1 0 01.707.293L9.828 3z"/>
            </svg>
          ) : (
            <ChartIcon type={node.chart_type || node.chartType} size={14} />
          )}
        </div>

        <span className="rp-tree-item-name">{node.name}</span>

        <div className="rp-tree-item-actions" onClick={(e) => e.stopPropagation()}>
          <button
            className="rp-tree-action-btn"
            onClick={(e) => { e.stopPropagation(); onContextMenu(e, node); }}
          >
            <svg viewBox="0 0 16 16" fill="currentColor">
              <path d="M9.5 13a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm0-5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm0-5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"/>
            </svg>
          </button>
        </div>
      </div>

      {isFolder && node.expanded && (node.children || []).map(child => (
        <TreeItem
          key={child.id}
          node={{ ...child, type: 'folder' }}
          depth={depth + 1}
          activeDocId={activeDocId}
          activeFolderId={activeFolderId}
          onSelect={onSelect}
          onToggle={onToggle}
          onContextMenu={onContextMenu}
          onRename={onRename}
          onDelete={onDelete}
          onShare={onShare}
        />
      ))}
      {isFolder && node.expanded && (node.documents || []).map(doc => (
        <TreeItem
          key={`doc-${doc.id}`}
          node={{ ...doc, type: 'doc' }}
          depth={depth + 1}
          activeDocId={activeDocId}
          activeFolderId={activeFolderId}
          onSelect={onSelect}
          onToggle={onToggle}
          onContextMenu={onContextMenu}
          onRename={onRename}
          onDelete={onDelete}
          onShare={onShare}
        />
      ))}
    </>
  );
};

// ── File Tree panel ────────────────────────────────────────────────────────────

const FileTree = ({ tree, activeDocId, onSelectDoc, onToggleFolder, onNewItem, onRename, onDelete, onShare }) => {
  const [search, setSearch] = useState('');
  const [ctxMenu, setCtxMenu] = useState(null);
  const [showNewDropdown, setShowNewDropdown] = useState(false);
  const [activeFolderId, setActiveFolderId] = useState(null);
  const newBtnRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handler = (e) => {
      if (newBtnRef.current && !newBtnRef.current.contains(e.target)) {
        setShowNewDropdown(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleContextMenu = (e, node) => {
    setCtxMenu({ x: e.clientX, y: e.clientY, node });
  };

  const filterNodes = (nodes, q) => {
    if (!q) return nodes;
    return nodes.reduce((acc, n) => {
      if (n.type === 'folder') {
        const filteredChildren = filterNodes(n.children || [], q);
        const filteredDocs = (n.documents || []).filter(d => d.name.toLowerCase().includes(q));
        if (filteredChildren.length > 0 || filteredDocs.length > 0) {
          acc.push({ ...n, expanded: true, children: filteredChildren, documents: filteredDocs });
        }
      } else {
        if (n.name.toLowerCase().includes(q)) acc.push(n);
      }
      return acc;
    }, []);
  };

  // Build display tree: folders + loose docs at root
  const allNodes = [
    ...(tree.folders || []),
    ...(tree.loose_documents || []).map(d => ({ ...d, type: 'doc' })),
  ];
  const displayTree = filterNodes(allNodes, search.toLowerCase());

  return (
    <div className="rp-filetree">
      <div className="rp-tree-topbar">
        <span className="rp-tree-title">Reporting</span>
        <div style={{ position: 'relative' }} ref={newBtnRef}>
          <button className="rp-btn rp-btn-primary rp-btn-sm" onClick={() => setShowNewDropdown(v => !v)}>
            <svg viewBox="0 0 16 16" fill="currentColor" width="12" height="12">
              <path d="M8 4a.5.5 0 01.5.5v3h3a.5.5 0 010 1h-3v3a.5.5 0 01-1 0v-3h-3a.5.5 0 010-1h3v-3A.5.5 0 018 4z"/>
            </svg>
            New
            <svg viewBox="0 0 16 16" fill="currentColor" width="9" height="9">
              <path d="M7.247 11.14l-4.796-5.481c-.566-.647-.106-1.659.753-1.659h9.592c.858 0 1.319 1.012.752 1.659l-4.796 5.48a1 1 0 01-1.505 0z"/>
            </svg>
          </button>
          {showNewDropdown && (
            <div className="rp-new-dropdown">
              {activeFolderId && (
                <div style={{ padding: '4px 12px 2px', fontSize: 10, color: 'var(--color-text-tertiary)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.4px' }}>
                  Inside selected folder
                </div>
              )}
              <button className="rp-new-item" onClick={() => { onNewItem(activeFolderId, 'folder'); setShowNewDropdown(false); }}>
                <svg viewBox="0 0 16 16" fill="currentColor" style={{ color: '#f59e0b' }} width="14" height="14">
                  <path d="M9.828 3h3.982a2 2 0 011.992 2.192l-.522 4.957A2 2 0 0113.292 12H3.706a2 2 0 01-1.982-1.851l-.395-5.93A2 2 0 013.31 2h6.516a1 1 0 01.707.293L9.828 3z"/>
                </svg>
                New Folder
              </button>
              <div className="rp-ctx-divider" />
              <button className="rp-new-item" onClick={() => { onNewItem(activeFolderId, 'doc'); setShowNewDropdown(false); }}>
                <span style={{ color: 'var(--color-brand)' }}><ChartIcon type="gantt" size={14} /></span>
                New Report
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="rp-tree-search">
        <svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor">
          <path d="M11.742 10.344a6.5 6.5 0 10-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 001.415-1.414l-3.85-3.85a1.007 1.007 0 00-.115-.1zM12 6.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0z"/>
        </svg>
        <input
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder="Search…"
        />
      </div>

      <div className="rp-tree-body">
        {displayTree.map(node => (
          <TreeItem
            key={`${node.type || 'folder'}-${node.id}`}
            node={node.type ? node : { ...node, type: 'folder' }}
            depth={0}
            activeDocId={activeDocId}
            activeFolderId={activeFolderId}
            onSelect={onSelectDoc}
            onToggle={(folder) => { setActiveFolderId(folder.id); onToggleFolder(folder); }}
            onContextMenu={handleContextMenu}
            onRename={onRename}
            onDelete={onDelete}
            onShare={onShare}
          />
        ))}
        {displayTree.length === 0 && !tree.shared_documents?.length && (
          <div className="rp-tree-empty">
            {search ? 'No results found' : 'No documents yet — create one above'}
          </div>
        )}

        {/* Shared with me */}
        {(tree.shared_documents || []).length > 0 && (
          <>
            <div className="rp-tree-section-label">Shared with me</div>
            {(tree.shared_documents || [])
              .filter(d => !search || d.name.toLowerCase().includes(search.toLowerCase()))
              .map(doc => (
                <TreeItem
                  key={`shared-${doc.id}`}
                  node={{ ...doc, type: 'doc' }}
                  depth={0}
                  activeDocId={activeDocId}
                  activeFolderId={activeFolderId}
                  onSelect={onSelectDoc}
                  onToggle={() => {}}
                  onContextMenu={() => {}}
                  onRename={() => {}}
                  onDelete={() => {}}
                  onShare={() => {}}
                />
              ))}
          </>
        )}
      </div>

      {ctxMenu && (
        <ContextMenu
          x={ctxMenu.x}
          y={ctxMenu.y}
          node={ctxMenu.node}
          onClose={() => setCtxMenu(null)}
          onRename={onRename}
          onDelete={onDelete}
          onNewItem={onNewItem}
          onShare={onShare}
        />
      )}
    </div>
  );
};

export default FileTree;
